import { defineNuxtRouteMiddleware } from 'nuxt/app';
import { useSupabaseClient } from '~/plugins/supabase';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!import.meta.client) return; // Ensure this only runs on client

  // Only track if navigating to a specific card page
  if (
    !to.fullPath.startsWith('/card/') || // Not a card route
    !to.params?.id || // No card ID present
    to.fullPath === from.fullPath // Same route (no actual navigation)
  ) {
    return;
  }

  const $supabase = useSupabaseClient();
  let source = 'external';
  let keyword = null;

  if (from.fullPath.includes('/search')) {
    source = 'search';
    const urlParams = new URLSearchParams(from.fullPath.split('?')[1] || '');
    keyword = urlParams.get('q');
  } else if (from.fullPath.startsWith('/')) {
    source = from.fullPath;
  }

  const cardData = {
    card_id: to.params.id,
    source,
    keyword,
  };

  try {
    const { error } = await $supabase.from('card_activity').insert(cardData);
    if (error) console.error('Error logging card activity:', error);
  } catch (e) {
    console.error('Unexpected error logging card activity:', e);
  }
});
